module.exports = __webpack_public_path__ + "static/media/applogo.fa3df7ff.svg";